import type { Prompt } from './types';

export const INITIAL_TEXT_PROMPT: Pick<Prompt, 'text' | 'html'> = {
  html: '',
  text: '',
};

export const INITIAL_FILE_PROMPT: Pick<
  Prompt,
  'file' | 'fileBase64' | 'base64'
> = {
  file: null,
  fileBase64: null,
  base64: null,
};

export const INITIAL_PROMPT: Prompt = {
  ...INITIAL_TEXT_PROMPT,
  ...INITIAL_FILE_PROMPT,
};

export const MODEL_OPTIONS = [
  { value: 'agent', label: 'Agent' },
  { value: 'anthropic:claude-opus-5', label: 'Opus 5' },
  { value: 'anthropic:claude-opus-5-5', label: 'Opus 5.5' },
  { value: 'anthropic:claude-fable-5', label: 'Fable 5' },
  { value: 'anthropic:claude-fable-5-1', label: 'Fable 5.1' },
  { value: 'openai:gpt-6.1-sol', label: 'GPT 6.1 Sol' },
  { value: 'openai:gpt-6-astra', label: 'GPT 6 Astra' },
] as const;

export const PROMPT_OPTIONS = [{ value: 'school', label: 'School' }] as const;

export const DEFAULT_SCHOOL_MODEL =
  'agent' satisfies (typeof MODEL_OPTIONS)[number]['value'];

export const DEFAULT_SCHOOL_PROMPT =
  'school' satisfies (typeof PROMPT_OPTIONS)[number]['value'];

export const DEFAULT_MAGIC_SCHOOL_PROMPT = 'schoolSchedule';
